<div *ngIf="!loading" class="absolute inset-0 flex flex-col justify-center gap-6">

    <button mat-button (click)="joinRoom()">
      Join as a participant
    </button>

    <button mat-button (click)="controlRoom()">
      Open remote control
    </button>


</div>
